module.exports = __webpack_public_path__ + "img/exchange-btn.42d71dd9.png";